export function getSeasonFromDate(date) {
    return date.getMonth() < 6 ?
        (date.getFullYear() - 1) * 10000 + date.getFullYear() :
        date.getFullYear() * 10000 + (date.getFullYear() + 1);
}
